import { forwardRef, type HTMLAttributes, type ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';

export interface ErrorStateProps extends Omit<HTMLAttributes<HTMLElement>, 'title'> {
  title: ReactNode;
  messages?: ReactNode[];
}

export const ErrorState = forwardRef<HTMLElement, ErrorStateProps>(function ErrorState(
  { title, messages = [], className, tabIndex = -1, ...rest },
  ref,
): ReactNode {
  return (
    <section
      ref={ref}
      role="alert"
      tabIndex={tabIndex}
      className={cn(
        'rounded-lg border border-[var(--danger-border)] bg-[var(--danger-surface)] p-4 text-sm text-[var(--text-primary)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--field-focus-ring)]',
        className,
      )}
      {...rest}
    >
      <p className="font-semibold text-[var(--danger-text)]">{title}</p>
      {messages.length > 0 ? (
        <ul className="mt-2 list-disc ps-5 text-[var(--text-secondary)]">
          {messages.map((message, index) => (
            <li key={index}>{message}</li>
          ))}
        </ul>
      ) : null}
    </section>
  );
});
